import { serverDateToLocal } from 'src/utils/date';
import CommonHead, { Metadata } from 'src/components/Common/CommonHead';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: GraphQL imports are bugged but functional. Ignored for now to make CircleCI happy.
import { AudioDetail } from 'src/api/audioContent/audioContent.graphql';

const getMetadata = (audioContent: AudioDetail): Metadata => {
  const { audio } = audioContent;
  return {
    title: audio?.title ? audio.title : '',
    author: 'Beek',
    orgAuthor: 'Beek',
    description: audio?.description ? audio.description : '',
    date: audio?.streetDate
      ? audio.streetDate
      : serverDateToLocal(new Date().toISOString()),
    category: 'Audiobooks',
    cover: audio?.coverUrl ? `${audio?.coverUrl}?width=1200&height=1200` : '',
    url: `/libros/${audio?.slug}`,
    tags: 'Beek',
    avoidSeoIndex: audio?.avoidSeoIndex ? audio?.avoidSeoIndex : false,
  };
};

type AudioContentHeaderProps = {
  audioContent: AudioDetail;
};

const AudioContentDetailHeader = (
  props: AudioContentHeaderProps
): JSX.Element => {
  const { audioContent } = props;
  const metadata = getMetadata(audioContent);
  return <CommonHead metadata={metadata} />;
};

export default AudioContentDetailHeader;
